import { render, staticRenderFns } from "./RoundRobinMatchInfo.vue?vue&type=template&id=587ecea4&scoped=true&"
import script from "./RoundRobinMatchInfo.vue?vue&type=script&lang=js&"
export * from "./RoundRobinMatchInfo.vue?vue&type=script&lang=js&"
import style0 from "./RoundRobinMatchInfo.vue?vue&type=style&index=0&id=587ecea4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "587ecea4",
  null
  
)

component.options.__file = "RoundRobinMatchInfo.vue"
export default component.exports